module.exports = __webpack_public_path__ + "img/configuration.201f383c.svg";